import React from 'react';
import { Form, Field } from 'react-final-form';
import createDecorator from 'final-form-calculate';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Table,
} from 'react-bootstrap';
import Select from 'react-select';
import BidToolbar from './BidToolbar';
import { required, validRate, validPercentage, positiveNumber, email } from '../../../forms';
import PhoneInput,{isValidPhoneNumber} from 'react-phone-number-input';
import { BootstrapTable, TableHeaderColumn, BootBootstrapButton } from 'react-bootstrap-table';
// import editBid from '../modules/booking';
import moment from 'moment';
import { monthNameFormatDate } from '../../../core/date';
import 'react-phone-number-input/style.css';
import flags from 'react-phone-number-input/flags';

const SelectInput = ({
  input,
  options,
  name,
  id,
  label,
  help,
  meta: { active, touched, error, warning },
}) => (
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      <Select
        id={id}
        name={name}
        options={options}
        value={input.value}
        onChange={(value) => {
          input.onChange(value.value);
        }}
        onBlur={value => input.onBlur(value.value)}
        joinValues
      />
      {help && <HelpBlock>{help}</HelpBlock>}
      {touched &&
        ((error && <p className="alert alert-danger">{error}</p>) ||
          (warning && <p className="alert alert-warning">{warning}</p>))}
    </FormGroup>
  );

export const renderTextField = ({ input, label, type, value, meta: { touched, error, warning } }) => (
  <FormGroup>
    {label && <ControlLabel>{label}</ControlLabel>}
    <FormControl {...input} type={type} value={value} />
  </FormGroup>
);

  const currencyOptions = [
    {
      label: '🇦🇺 AUD - Australian Dollar',
      value: 'AUD',
    },
    {
      label: '🇨🇦 CAD - Canadian Dollar',
      value: 'CAD',
    },
    {
      label: '🇨🇳 CNY - Chinese Yuan Renminbi',
      value: 'CNY',
    },
    {
      label: '🇪🇺 EUR - Euro',
      value: 'EUR',
    },
    {
      label: '🇬🇧 GBP - British Pound',
      value: 'GBP',
    },
    {
      label: '🇯🇵 JPY - Japanese Yen',
      value: 'JPY',
    },
    {
      label: '🇲🇽 MXN - Mexican Peso',
      value: 'MXN',
    },
    {
      label: '🇺🇸 USD - US Dollar',
      value: 'USD',
    },
    {
      label: '🇳🇿 ZND - New Zealand Dollar',
      value: 'ZND',
    },
    {
      label: '🇧🇷 BRL - Brazilian Real',
      value: 'BRL',
    },
    {
      label: '🇦🇷 ARS - Argentinian peso',
      value: 'ARS',
    },
    {
      label: '🇨🇱 CLP - Chilean Peso',
      value: 'CLP',
    },
    {
      label: '🇩🇰 DKK - Danish Krone',
      value: 'DKK',
    },
    {
      label: '🇮🇳 INR - Indian Rupee',
      value: 'INR',
    },
    {
      label: '🇰🇷 KRW - Korean Won',
      value: 'KRW',
    },
    {
      label: '🇳🇴 NOK - Norwegian Krone',
      value: 'NOK',
    },
    {
      label: '🇷🇺 RUB - Russian Ruble',
      value: 'RUB',
    },
    {
      label: '🇨🇭 CHF - Swiss Franc',
      value: 'CHF',
    },
    {
      label: '🇦🇪 AED - UAE Dirham',
      value: 'AED',
    },
    {
      label: '🇿🇦 ZAR - South African Rand',
      value: 'ZAR',
    },
    {
      label: '🇮🇸 ISK - Icelandic Krona',
      value: 'ISK',
    },
    {
      label: '🇮🇱 ILS - Israel new Shekel',
      value: 'ILS',
    },
    {
      label: '🇵🇱 PLN - Polish Zloty',
      value: 'PLN',
    },
    {
      label: '🇶🇦 QAR - Qatari Riyal',
      value: 'QAR',
    },
    {
      label: '🇹🇷 TRY - Turkish Lira',
      value: 'TRY',
    },
    {
      label: '🇸🇪 SEK - Swedish krona',
      value: 'SEK',
    },
  ];
  
const getValidationStyle = (touched, errorMsg) => {
  if (!errorMsg || !touched) {
    return '';
  }
  return 'error';
};

const getBorderStyle = (touched, errorMsg) => {
  const style = {
    border: '1px solid #ccc',
    borderBottom: 'none',
    textAlign: 'right',
    paddingRight: '10px',
  };
  if (touched && errorMsg) {
    style.border = '1px solid #a94442';
    style.borderBottom = '1px solid #a94442';
  }
  return style;
};

export const MoneyInput = ({
  input,
  label,
  type,
  placeholder,
  meta: { touched, error, warning },
}) => (
    <FormGroup validationState={getValidationStyle(touched, error)}>
      <InputGroup
        style={{
          display: 'table',
          margin: 0,
        }}
      >
        <InputGroup.Addon>$</InputGroup.Addon>
        <FormControl
          {...input}
          type={type}
          style={getBorderStyle(touched, error)}
          placeholder={placeholder}
        />
      </InputGroup>
    </FormGroup>
  );

export const PercentageInput = ({ input, label, type, meta: { touched, error, warning } }) => {
  return (
    <FormGroup validationState={getValidationStyle(touched, error)}>
      <InputGroup
        style={{
          display: 'table',
          width: '50%',
        }}
      >
        <InputGroup.Addon>{label}</InputGroup.Addon>
        <FormControl {...input} type={type} style={getBorderStyle(touched, error)} />
        <InputGroup.Addon>%</InputGroup.Addon>
      </InputGroup>
      <FormControl.Feedback />
    </FormGroup>
  )
};

export const LabeledInput = ({ input, label, placeholder, help, type, meta }) => (
  <InputGroup>
    <ControlLabel>{label}</ControlLabel>
    <FormControl {...input} type={type} placeholder={placeholder} />
    {help && <HelpBlock>{help}</HelpBlock>}
    {meta.touched &&
      ((meta.error && (
        <div>
          <span className="danger">{meta.error}</span>
        </div>
      )) ||
        (meta.warning && (
          <div>
            <span className="danger">{meta.warning}</span>
          </div>
        )))}
  </InputGroup>
);
export const ReadOnlyInput = ({ input, label, placeholder, help, type, value, meta }) => (
  <InputGroup>
    <ControlLabel>{label}</ControlLabel>
    <FormControl {...input} type={type} placeholder={placeholder} value={value} readOnly />
    {help && <HelpBlock>{help}</HelpBlock>}
    { /*meta.touched &&
      ((meta.error && (
        <div>
          <span className="danger">{meta.error}</span>
        </div>
      )) ||
        (meta.warning && (
          <div>
            <span className="danger">{meta.warning}</span>
          </div>
        )))*/}
  </InputGroup>
);

export const HiddenInput = ({ input, label, placeholder, help, type, meta }) => (
  <InputGroup>
    <FormControl {...input} type="hidden" />
  </InputGroup>
);

const NoteInput = ({ input, label, type, help, meta }) => (
  <FormGroup>
    <ControlLabel>Note</ControlLabel>
    <FormControl
      {...input}
      componentClass="textarea"
      name="note"
      placeholder="Add a note about your offer."
    />
    {help && <HelpBlock>{help}</HelpBlock>}
  </FormGroup>
);

const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

const calculator = createDecorator({
  field: /\S*_rate/, // when a field matching this pattern changes...
  updates: {
    // ...update the total to the result of this function
    total: (ignoredValue, allValues) => {
      let sum = 0;
      if (allValues.suites) {
        sum += Number(allValues.suite_rate || 0) * allValues.suites * allValues.nights;
      }
      if (allValues.kings) {
        sum += Number(allValues.king_rate || 0) * allValues.kings * allValues.nights;
      }
      if (allValues.queens) {
        sum += Number(allValues.queen_rate || 0) * allValues.queens * allValues.nights;
      }
      if (allValues.hotel.tax_rate) {
        sum += Number(allValues.hotel.tax_rate / 100.0 || 0) * sum;
      }
      return sum;
    },
  },
});

const parsePercent = (value) => {
  if (!value || value.charAt(value.length - 1) === '.') return value;
  return typeof value === 'number' ? value : parseFloat(value.replace(/[^\d.]/g, '')).toFixed(3);
};

const formatMoney = (value, currency) => {
  if (!value) return value;
  // const onlyNums = value.replace(/[^\d]/g, '');
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    minimumFractionDigits: 2,
    currency,
  });
  return formatter.format(value);
};

const formatstyle = (value) => {
  if (!value) return { border: '1px solid red' };
  return null;
};


const Error = ({ name }) => (
  <Field
    name={name}
    subscription={{ touched: true, error: true }}
    render={({ meta: { touched, error } }) =>
      touched && error ? <span className="alert-danger">{error}</span> : null
    }
  />
);

const roomNameFormatter = (cell, row) => {
  switch (cell) {
    case 1:
      return 'Suite'
    case 2:
      return 'King'
    case 3:
      return 'Double'
    case 4:
      return 'Two Beds'
    case 5:
      return 'Junior Suite'
    case 6:
      return '2 Bedroom Suite'
  }
}

const numberOfDayFormatter = (cell, row) => {
  const a = moment(row.check_out_date);
  const b = moment(row.check_in_date);
  return a.diff(b, 'days')
}

const displayDate = (cell, row) => {
  return monthNameFormatDate(cell);
}

function getRow(cell, row, enumObject) {

  enumObject(row);

}

const BidDetailForm = ({
  profilename,
  tour,
  onSubmit,
  initialValues,
  bid,
  displayBidAssignment,
  closeBidAssignment,
  editBid,
  isNew,
  bidData,
  bid_details_input,
  onRateChange,
  onDetailsChange,
  onAnswerChange,
  onPhoneNoChange,
  resetValues,
  handleEditclose,
  cellEditProp,
  onCurrencyChange,
  isValidRatePerNight,
  isDisabled,
  disabled,
  addedanswers
}) => (

    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit, reset, submitting, pristine, errors, values }) => (
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <ControlLabel>Currency</ControlLabel>
            <Select
              name="currency"
              options={currencyOptions}
              value={bid_details_input.currency}
              onChange={onCurrencyChange}
            />
          </FormGroup>

          <FormGroup>
            <InputGroup
              style={{
                display: 'table',
                width: '50%',
              }}
            >
              <InputGroup.Addon>Tax Rate</InputGroup.Addon>
              <FormControl required validate={composeValidators(required, validPercentage)} type="number" min="0.00" max="99.999" step="0.001" value={bid_details_input.tax_rate} onChange={(e) => onRateChange(e, "tax_rate")} style={getBorderStyle(false, false)} />
              <Error name="tax_rate" />
              <InputGroup.Addon>%</InputGroup.Addon>
            </InputGroup>
            <FormControl.Feedback />
          </FormGroup>
          <Field name="nights" type="text" component={HiddenInput} disabled label="Nights" />
          <BootstrapTable
            data={bid_details_input.bidData}
            striped
            cellEdit={cellEditProp}
            tableStyle={{ marginBottom: '5px' }}
          >
            <TableHeaderColumn dataField="rate_per_night" width="100" headerAlign="center" tdStyle={(cell) => formatstyle(cell)} dataAlign="center" dataFormat={(cell) => formatMoney(cell, bid_details_input.currency)} editable={{ type: "number" }}>Rate Per Night</TableHeaderColumn>
            <TableHeaderColumn dataField="room_type" width="100" isKey headerAlign="center" dataAlign="center" dataFormat={roomNameFormatter}>Room Type</TableHeaderColumn>
            <TableHeaderColumn dataField="room_category" width="100" headerAlign="center" dataAlign="center"  editable={{ type: "text" }}>Room Category</TableHeaderColumn>
            <TableHeaderColumn dataField="no_of_Guest" width="100" headerAlign="center" dataAlign="center" editable={false} >No of Rooms</TableHeaderColumn>
            <TableHeaderColumn dataField="check_in_date" width="100" headerAlign="center" dataAlign="center" dataFormat={displayDate} editable={false} >Check in Date</TableHeaderColumn>
            <TableHeaderColumn dataField="check_out_date" width="100" headerAlign="center" dataAlign="center" dataFormat={displayDate} editable={false}>Check out Date</TableHeaderColumn>
            <TableHeaderColumn width="100" headerAlign="center" dataAlign="center" editable={false} dataFormat={numberOfDayFormatter}>No of Days</TableHeaderColumn>
            
          </BootstrapTable>
          
          <span style={{ color: "red", fontSize: '12px' }}> *Rate Per Night' field is required and only use numbers.</span><br/>
          <span style={{ color: "red", fontSize: '12px' }}>*If you cannot accommodate the group please select 'Sold out'.</span><br/><br/>
          <div style={{ color: "red", fontSize: '12px',marginLeft:'50%', overflowWrap: "break-word" }}>
              <span>*Please DO NOT put tax percentage in the additional tax field. Additional tax is only for any tax above your daily tax %.</span><br/>
          </div>

          <FormGroup style={{ marginTop: "20px" }}>
            <div className="row">
              <div className="col-md-6">
              <InputGroup
                style={{
                  display: 'table',
                  width: '100%',
                  marginTop: '15px'
                }}
              >
                <InputGroup.Addon>Commission</InputGroup.Addon>
                <FormControl required type="number" step="0.00" min="0.00" max="99.99" value={bid_details_input.commission_rate} onChange={(e) => onRateChange(e, "commission_rate")} style={getBorderStyle(false, false)} />
                <InputGroup.Addon>%</InputGroup.Addon>
              </InputGroup>
              <FormControl.Feedback />
              </div>
              <div className="col-md-3 bid-detail-form-additional-tax">
              <ControlLabel>Additional Tax (per day)</ControlLabel>
              <FormControl name="additional_tax" component={renderTextField} type="number" value={bid_details_input.additional_tax} step="0.01" min="0.00" max="99.99" onChange={(e) => onRateChange(e, "additional_tax")} />
              </div>
              <div className="col-md-3 bid-detail-form-additional-tax">
              <ControlLabel>Resort Fee (per day)</ControlLabel>
              <FormControl name="resort_fee" component={renderTextField} type="number" value={bid_details_input.resort_fee} step="0.00" min="0.00" max="99.99" onChange={(e) => onRateChange(e, "resort_fee")} />
              </div>
          </div>
          </FormGroup>
          <ReadOnlyInput
            type="text"
            readOnly
            placeholder="Enter rates for this value to be calculated."
            label="Total"
            help="Estimated total including tax"
            value={bid_details_input.total}
          />
          {addedanswers?
            (addedanswers.map((q)=>(
              <FormGroup>
                <InputGroup>
                  <InputGroup>{q.question}</InputGroup>
                  <FormControl required type="text" placeholder="Enter a answer" value={q.answer} onChange={(e) => onAnswerChange(e,q)}/>
                  <Error name={q.question} />
                </InputGroup>
              </FormGroup>
              ))):("")}
          {isNew && (
            <Field
              name="note"
              type="textarea"
              component={NoteInput}
              label="Note"
              help="Please enter pricing and commission in appropriate boxes. Do not put commission in notes area. Use this area to clarify offering or to ask questions."
            />
          )}
          
          <FormGroup>
            <InputGroup>
              <InputGroup>Name</InputGroup>
              <FormControl type="text" placeholder="Enter a name" value={bid_details_input.name} onChange={(e) => onDetailsChange(e, "name")}/>
              <Error name="name" />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <InputGroup>
              <InputGroup>Email</InputGroup>
              <FormControl type="email" placeholder="Enter an email" value={bid_details_input.email} onChange={(e) => onDetailsChange(e, "email")}/>
              <Error name="email" />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <InputGroup>Phone (Please select a Country and provide Phone Number)</InputGroup>
              <PhoneInput 
                flags={flags} 
                international 
                type="text" 
                placeholder="Enter phone number" 
                value={bid_details_input.contact} 
                country="US" 
                onChange={(e) => onPhoneNoChange(e)}
                error={bid_details_input.contact?(isValidPhoneNumber(bid_details_input.contact)?undefined:<span style={{ color: "red"}}>Invalid phone number</span>):"Phone number required"}
                />
              <Error name="contact" />
          </FormGroup><br/>

          {!isValidRatePerNight && (
            <span style={{ color: "red", fontSize: '12px' }}> <sup>*</sup> Rate Per Night is required.</span>
           )}
          
          <div className="form-group">
            <ButtonGroup>
              <Button bsStyle="success" type="submit" disabled={isNew? disabled : disabled}>
                {isNew ? 'Submit Bid' : 'Update Bid'}
              </Button>
              {isNew ? (''):(
              <Button style={{'margin-left': "10px", 'margin-right': "10px"}} bsStyle="success" onClick={resetValues}>
                Reset
              </Button>
              )}
              {isNew ? (''):(
                <Button bsStyle="danger" onClick={handleEditclose}>
                  Cancel
                </Button>
              )} 

              <BidToolbar style={{'margin-right': "10px"}}  profilename={profilename} tour={tour}  bid={bid} editBid={editBid} displayBidAssignment={displayBidAssignment} />
            </ButtonGroup>
          </div>
        </form >
      )}
    />
  );

export default BidDetailForm;



// WEBPACK FOOTER //
// src/routes/booking/components/BidDetailForm.js